var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "공용작업실",
            "tabActive": "신설동 스케쥴",
            "bg": "/images/sub/sub-visual5.jpg"
          },
          scopedSlots: _vm._u([{
            key: "tit",
            fn: function () {
              return [_vm._v("공용작업실")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("신설동 스케쥴")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pb-30px pb-md-40px"
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-arrow-secondary', {
    on: {
      "click": _vm.prev
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$refs.calendar ? _c('tit-primary', {
    staticClass: "line-height-1"
  }, [_vm._v(_vm._s(_vm.$refs.calendar.title))]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-arrow-secondary', {
    attrs: {
      "direction": "right"
    },
    on: {
      "click": _vm.next
    }
  })], 1)], 1)], 1), _c('v-calendar', {
    ref: "calendar",
    attrs: {
      "type": "month",
      "event-overlap-mode": "stack",
      "show-month-on-first": false,
      "day-format": _vm.dayFormat,
      "events": _vm.events,
      "event-overlap-threshold": 30,
      "event-height": 24,
      "event-margin-bottom": 8,
      "color": "primary",
      "event-text-color": "grey",
      "event-color": "grey lighten-5"
    },
    on: {
      "change": _vm.getEvents,
      "click:date": _vm.showDetail,
      "click:event": _vm.showDetail
    },
    scopedSlots: _vm._u([{
      key: "event",
      fn: function (_ref) {
        var event = _ref.event;
        return [_vm._v(" " + _vm._s(event.name) + " ")];
      }
    }]),
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }